import type { GlAccountFormValues } from "../schemas/glAccountForm"

import type { GlAccountUpsertInput } from "@/graphql/codegen/graphql"

export const serializeGlAccountFormData = (
  formValues: GlAccountFormValues,
  glAccountId?: string | null
): GlAccountUpsertInput => {
  return {
    glAccountId,
    companyName: formValues.company,
    costCenter: formValues.costCenter || undefined,
    number: formValues.number,
    subNumber:
      typeof formValues.subNumber === "string" && formValues.subNumber !== ""
        ? Number.parseInt(formValues.subNumber, 10)
        : undefined,
    title: formValues.title,
    description: formValues.description || undefined,
    type: formValues.type || undefined,
    subType: formValues.subType || undefined,
    classification: formValues.classification || undefined,
    currency: formValues.currency,
    balance: formValues.balance || undefined,
    parentGlAccountId: formValues.parentGlAccountId || undefined,
    isActive: true,
  }
}
